import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SnackbarService } from '../shared/services/snackbar.service';
import { RequestsService } from '../shared/services/requests.service';

@Component({
    selector: 'app-return-reason-dialog',
    templateUrl: './return-reason-dialog.component.html',
    styleUrls: ['./return-reason-dialog.component.scss']
})
export class ReturnReasonDialogComponent {
    reasonForm: FormGroup;
    actionstepMatterUrl: string = '';
    actionstepBaseUrl: string = '';
    matterNo = '';
    accountsStage = false;
    partnerStage = false;
    selectedBankAccountId: string = '';

    constructor(
        private fb: FormBuilder,
        public dialogRef: MatDialogRef<ReturnReasonDialogComponent>,
        private snackbarService: SnackbarService,
        private requestService: RequestsService,
        @Inject(MAT_DIALOG_DATA) public data: { stageName: string, matterNo: string, currentStageId: number, rpaStatus: boolean, selectedBankAccountId: string }
    ) {
        this.reasonForm = this.fb.group({
            reason: ['', Validators.required],
            isRPAReversalRequested: [''],
            isTransactionReversed: [''],
            isRejectionRequested: ['']
        });
        this.matterNo = this.data.matterNo;
        this.selectedBankAccountId = this.data.selectedBankAccountId;

        this.accountsStage = (this.data?.currentStageId == 6 && this.data?.rpaStatus === true) || (this.data?.currentStageId == 4 && this.data?.rpaStatus === true);
        this.partnerStage = (this.data?.currentStageId == 5 && this.data?.rpaStatus === true);
        if (this.accountsStage) {
            this.reasonForm.get('isRPAReversalRequested')?.setValidators([Validators.required]);
        }

        if (this.partnerStage) {
            this.reasonForm.get('isRejectionRequested')?.setValidators([Validators.required]);
        }
    }

    async ngOnInit() {
        this.actionstepBaseUrl = await this.requestService.getActionstepUrl();
        this.actionstepMatterUrl = `${this.actionstepBaseUrl}?action_id=${this.matterNo}&ac_account_id=${this.selectedBankAccountId}`;

        this.reasonForm.get('isRPAReversalRequested')?.valueChanges.subscribe(value => {
            const reversedControl = this.reasonForm.get('isTransactionReversed');

            if (value === 'Yes') {
                reversedControl?.setValidators([Validators.required]);
            } else {
                reversedControl?.clearValidators();
                reversedControl?.setValue(''); 
            }

            reversedControl?.updateValueAndValidity();
        });
    }

    onUrlCopied() {
        this.snackbarService.successSnackBar("URL copied to clipboard");
    }

    submit() {
        if (this.reasonForm.valid) {
            this.dialogRef.close({
                reason: this.reasonForm.value.reason,
                isRPAReversalRequested: this.reasonForm.value.isRPAReversalRequested === 'Yes',
                isRejectionRequested: this.reasonForm.value.isRejectionRequested === 'Yes',
            });
        }
    }

    cancel() {
        this.dialogRef.close();
    }

    closeDialog() {
        this.dialogRef.close(true);
    }
}
